import { useCallback } from 'react';
import { NumberFormatOptions, useFormatter } from 'use-intl';
import { formatEther } from 'viem';

const useCustomFormatter = () => {
  const { number } = useFormatter();

  const bigintToEth = useCallback(
    (value?: bigint, opts?: NumberFormatOptions) => {
      if (value == null) return null;
      return number(Number(formatEther(value)), opts);
    },
    [number]
  );
  return {
    bigintToEth,
  };
};

export default useCustomFormatter;
